// src/components/PrivacyPage.js

import { useLanguage } from "../i18n/LanguageContext";
import privacyTranslations from "../i18n/legal/privacyTranslations";

export default function PrivacyPage({
  goBackToHome,
}) {
  const { language } = useLanguage();

  const content =
    privacyTranslations[language] ||
    privacyTranslations.en;

  return (
    <div style={pageStyles.page}>
      <div style={pageStyles.container}>

        <button
          style={pageStyles.backButton}
          onClick={goBackToHome}
        >
          {content.back}
        </button>

        <div style={pageStyles.header}>
          <div style={pageStyles.eyebrow}>
            {content.eyebrow}
          </div>

          <h1 style={pageStyles.title}>
            {content.title}
          </h1>

          <p style={pageStyles.subtitle}>
            {content.effectiveDate}
          </p>
        </div>

        {content.translationNotice && (
          <div style={pageStyles.translationNotice}>
            <strong>
              {language === "zh"
                ? "翻译说明："
                : language === "es"
                ? "Aviso sobre la traducción: "
                : language === "ru"
                ? "Примечание о переводе: "
                : ""}
            </strong>

            {content.translationNotice}
          </div>
        )}

        <section style={pageStyles.card}>
          <p style={pageStyles.paragraph}>
            {content.intro}
          </p>

          {content.sections.map(
            (section, sectionIndex) => (
              <div key={sectionIndex}>

                <h2 style={pageStyles.heading}>
                  {section.title}
                </h2>

                {section.paragraphs.map(
                  (
                    paragraph,
                    paragraphIndex
                  ) => (
                    <p
                      key={paragraphIndex}
                      style={
                        pageStyles.paragraph
                      }
                    >
                      {paragraph}
                    </p>
                  )
                )}

                {sectionIndex ===
                  content.sections.length -
                    1 && (
                  <p style={pageStyles.contact}>
                    {content.contactEmail}
                  </p>
                )}
              </div>
            )
          )}
        </section>

      </div>
    </div>
  );
}


const pageStyles = {
  page: {
    minHeight: "100vh",
    background:
      "linear-gradient(180deg, #f7f9fc 0%, #ffffff 100%)",
    padding: "32px 18px 60px",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    color: "#172033",
  },

  container: {
    width: "100%",
    maxWidth: "900px",
    margin: "0 auto",
  },

  backButton: {
    border: "none",
    background: "transparent",
    color: "#2563eb",
    cursor: "pointer",
    padding: 0,
    marginBottom: "24px",
    fontWeight: 700,
  },

  header: {
    marginBottom: "24px",
  },

  eyebrow: {
    color: "#2563eb",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "1.8px",
    marginBottom: "8px",
  },

  title: {
    margin: "0 0 8px",
    fontSize: "38px",
    fontWeight: 850,
  },

  subtitle: {
    margin: 0,
    color: "#64748b",
  },

  translationNotice: {
    marginBottom: "20px",
    padding: "14px 18px",
    borderRadius: "12px",
    background: "#eff6ff",
    border: "1px solid #bfdbfe",
    color: "#475569",
    fontSize: "13px",
    lineHeight: 1.7,
  },

  card: {
    background: "#ffffff",
    border: "1px solid #e2e8f0",
    borderRadius: "20px",
    padding: "34px",
    boxShadow:
      "0 8px 28px rgba(15,23,42,0.05)",
  },

  heading: {
    margin: "30px 0 10px",
    fontSize: "20px",
    fontWeight: 800,
  },

  paragraph: {
    color: "#475569",
    lineHeight: 1.8,
    fontSize: "14px",
  },

  contact: {
    color: "#2563eb",
    fontWeight: 800,
  },
};